import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, inject, LOCALE_ID, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, TitleStrategy } from '@angular/router';
import * as Sentry from '@sentry/angular';
import packageInfo from './../package.json';

import { registerLocaleData } from '@angular/common';
import langDe from '@angular/common/locales/de';
import langEnGb from '@angular/common/locales/en-GB';
import langFr from '@angular/common/locales/fr';
import langNl from '@angular/common/locales/nl';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ARLogger } from '@relayter/core';
import { NUC_FORM_FIELD_ERROR_MESSAGES, NUC_FULL_MODAL_SCROLL_STRATEGY_PROVIDER, NucToastService, provideNucTooltipDefaults } from '@relayter/rubber-duck';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { CustomDateAdapter } from './app/adapters/custom-date.adapter';
import { Toaster } from './app/classes/toaster.class';
import { RLValidatorConstants } from './app/classes/validators/rl-validators.constant';
import { AppComponent } from './app/components/app/app.component';
import { httpInterceptorProviders } from './app/http-interceptors';
import { RELAYTER_DATE_FORMATS } from './app/pipes/rl-date.pipe';
import { RelayterPageTitleStrategy } from './app/router/relayter-page-title-strategy';
import { ROUTE_DEFINITIONS } from './app/router/router.constants';
import { RLSegmentService } from './app/services/segment/rl-segment.service';
import { environment } from './environments/environment';
import { PROJECT_VARIABLES } from './environments/project_variables';

// Register languages for (date) localization
registerLocaleData(langEnGb);
registerLocaleData(langNl);
registerLocaleData(langFr);
registerLocaleData(langDe);

// Early Sentry init to catch unhandled errors
Sentry.init({
    dsn: environment.SENTRY_DNS,
    environment: environment.ENV,
    release: packageInfo.version,
    enabled: environment.ENV !== PROJECT_VARIABLES.environments.LOCAL,
    integrations: [],
    sampleRate: 1
});

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        provideRouter(ROUTE_DEFINITIONS),
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        NUC_FULL_MODAL_SCROLL_STRATEGY_PROVIDER,
        httpInterceptorProviders,
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({ showDialog: false })
        },
        provideAppInitializer(() => {
            ARLogger.setEnvironment(environment.ENV);
            Toaster.initialize(inject(NucToastService));
            inject(RLSegmentService).initialize();
        }),
        provideNucTooltipDefaults(),
        { provide: LOCALE_ID, useValue: navigator.language },
        { provide: MAT_DATE_LOCALE, useExisting: LOCALE_ID },
        { provide: MAT_DATE_FORMATS, useValue: RELAYTER_DATE_FORMATS },
        { provide: DateAdapter, useClass: CustomDateAdapter },
        provideCharts(withDefaultRegisterables()),
        { provide: TitleStrategy, useClass: RelayterPageTitleStrategy },
        { provide: NUC_FORM_FIELD_ERROR_MESSAGES, useValue: RLValidatorConstants.FORM_FIELD_ERROR_MESSAGES_VALUE }
    ]
}).catch(Sentry.captureException);
